// Import-free so a jest test can load it: `use-chat.ts` reaches common-lib, which does not load under CI's jest.

/**
 * The chat cards this web build can draw, sent on every user message so the harness knows which shapes
 * are worth sending. `share-someone-else`: a share offer's "Send to someone else" — without it the
 * harness withholds a share card that has no names on it, because a build that cannot draw the choice
 * would show a card with nothing to click. Mirrors common-lib's CLIENT_CAPABILITY_SHARE_SOMEONE_ELSE
 * (this package cannot import common-lib from `lib/`). `invite-card` / `pack-share-card`: this build draws
 * `inviteCard` and `packShareCard`, so the harness may spend their one-time asks on this reply.
 * `home-seo-insights`: this build draws Home's SEO and traffic insight kinds (common-lib
 * CLIENT_CAPABILITY_HOME_SEO_INSIGHTS), so the harness may card them. `meeting-connect-chip`: this build draws
 * the meeting connect chip, so the harness may offer it instead of the Connectors answer.
 */
export const WEB_CLIENT_CAPABILITIES = ['share-someone-else', 'invite-card', 'pack-share-card', 'home-seo-insights', 'meeting-connect-chip'] as const;
